export type ContractedCompany = {
  name: string;
  website?: string;
};

// 공개에 동의한 계약 회사만 하나씩 추가합니다.
// 예: { name: '회사명', website: 'https://example.com' }
// 프로젝트·서비스명은 이 목록에 넣지 않습니다.
export const contractedCompanies: ContractedCompany[] = [];
